/*
 * @Author: Chao Yang
 * @Date: 2019-11-25 03:34:13
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-03-20 12:41:36
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlterDomusSplashScreenComponent } from '../alter-domus-splash-screen/alter-domus-splash-screen.component';
import { AlterDomusStickyFillDirective } from '../alter-domus-sticky-fill/alter-domus-sticky-fill.directive';
import { AlterDomusTemplateDirective } from '../alter-domus-template/alter-domus-template.directive';
import { AlterDomusSafePipe } from '../pipe/index';
import { AlterDomusLoadingComponent } from '../alter-domus-loading/alter-domus-loading.component';

@NgModule({
  declarations: [
    AlterDomusSafePipe,
    AlterDomusSplashScreenComponent,
    AlterDomusStickyFillDirective,
    AlterDomusTemplateDirective,
    AlterDomusLoadingComponent
  ],
  exports: [
    AlterDomusSafePipe,
    AlterDomusSplashScreenComponent,
    AlterDomusStickyFillDirective,
    AlterDomusTemplateDirective,
    AlterDomusLoadingComponent
  ],
  imports: [CommonModule]
})
export class AdCommonModule { }
